export class RoleName {
  static readonly Administrators = 'Administrators';
  static readonly Registered = 'Registered';
  static readonly Guests = 'Guests';
  static readonly Offices = 'Offices';
  static readonly Employees = 'Employees';
  static readonly Traders = 'Traders';
}
